import {DI_TOKENS} from '@/di/di.tokens';

import {Container} from 'brandi';

import {ProjectUserAuthCreator} from '@specials/project-user';

import {ProjectApiHeaders} from '@/services/ProjectApi/ProjectApiHeaders';
import {ProjectUserInfoData, ProjectUserLoginData} from '@/services/ProjectAuthApi/types';
import {AuthStore} from '@/stores/AuthStore/AuthStore';

export function initAuthDeps(container: Container): void {
  container.bind(DI_TOKENS.projectApiHeaders).toInstance(ProjectApiHeaders).inSingletonScope();

  if (process.env.APP_PROJECT_AUTH_API_MOCK_ENABLED === 'true') {
    container
      .bind(DI_TOKENS.projectAuthApi)
      .toInstance(require('@/services/ProjectAuthApi/ProjectAuthApiMock').ProjectAuthApiMock)
      .inSingletonScope();
  } else {
    container
      .bind(DI_TOKENS.projectAuthApi)
      .toInstance(require('@/services/ProjectAuthApi/ProjectAuthApi').ProjectAuthApi)
      .inSingletonScope();
  }

  const {APP_SSO_API_URL, APP_SSO_CLIENT_URL, APP_PROJECT_URL} = container.get(DI_TOKENS.envs);

  container
    .bind(DI_TOKENS.projectUserAuth)
    .toInstance(() =>
      ProjectUserAuthCreator.create<ProjectUserInfoData, ProjectUserLoginData>({
        ssoApi: APP_SSO_API_URL,
        ssoClientApi: APP_SSO_CLIENT_URL,
        projectApi: container.get(DI_TOKENS.projectAuthApi),
        srcOrigin: APP_PROJECT_URL,
      }),
    )
    .inSingletonScope();
  container.bind(DI_TOKENS.authStore).toInstance(AuthStore).inSingletonScope();
}
